import React, { useCallback } from 'react';
import { Box, Grid, IconButton, Stack } from "@mui/material";
import { formatMediumAvailabilityPeriod, MediumAvailability } from "../../../../../model/Medium";
import { NumberishId } from "../../../../../model/type";
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import { Edit } from "@mui/icons-material";
import PriceEditionDialog from "./PriceEditionDialog";
import getOfferId from "../../../../../core/getOfferId";
import { UpdateManyAvailabilities } from "../../../../../action/updateManyAvailabilities";

const AvailabilitySubCell: React.FC<AvailabilitySubCellProps> = props => {
    const availability = props.availability;

    const offerId = getOfferId();

    const [priceDialogOpen, setPriceDialogOpen] = React.useState(false);

    const onEditPriceClick = useCallback(e => {
        e.stopPropagation();
        setPriceDialogOpen(true);
    }, []);

    return (
        <>
            <Grid
                key={ availability.id }
                container
                spacing={ 1 }
                alignItems='center'
            >
                <Grid item container xs={ 4 }>
                <span style={ { whiteSpace: 'nowrap' } }>
                    { formatMediumAvailabilityPeriod(availability) }
                </span>
                </Grid>
                <Grid item container xs={ 3.5 }>
                <span style={ { whiteSpace: 'nowrap' } }>
                    { availability.cost ? `${ availability.cost } zł` : '' }
               </span>
                </Grid>
                <Grid item container xs={ 3.5 }>
                    <Stack direction='row' spacing={ 1 } alignItems='center'>
                        <IconButton size='small' onClick={ onEditPriceClick }>
                            <Edit fontSize='small'/>
                        </IconButton>
                        <span style={ { whiteSpace: 'nowrap' } }>
                        { availability.price ? `${ availability.price } zł` : '' }
                    </span>
                    </Stack>
                </Grid>
                <Grid item container xs={ 1 } alignItems='center'>
                    {
                        availability.accepted &&
                        <Box title='Dostępność wybrana przez klienta' height='18px'>
                            <AssignmentTurnedInIcon color='success' fontSize='small'/>
                        </Box>
                    }
                </Grid>
            </Grid>
            {
                priceDialogOpen &&
                <PriceEditionDialog
                    onClose={ () => setPriceDialogOpen(false) }
                    onSubmit={
                        values => props.updateManyAvailabilities(
                            offerId,
                            [],
                            [availability.id],
                            values
                        ).then(
                            () => {
                                setPriceDialogOpen(false);
                                props.onEdit();
                            }
                        )
                    }
                />
            }
        </>
    );
}
export default React.memo(AvailabilitySubCell);

export interface AvailabilitySubCellProps {
    readonly mediumId: NumberishId;
    readonly availability: MediumAvailability;
    readonly onEdit: () => void;
    readonly updateManyAvailabilities: UpdateManyAvailabilities;
}